import BaseModel from '../core/BaseModel'
export default class LoyaltyLevelModel extends BaseModel {
    constructor() {
        super({
            name: "loyalty_level",
            tableName: 'loyalty_level',
            label: "loyalty_level",
            display_key: 'level'
        }, {
            stt: {
                name: "stt",
                label: "No.",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
            },
            id: {
                name: 'id',
                type: "Uuid",
                label: 'ID',
                primaryKey: true,
                display: false
            },
            level: {
                name: 'name',
                type: "String",
                label: 'Name',
            },
            earning_point_from: {
                name: 'level',
                type: "String",
                label: 'level'
            },
            key : {
                name: 'key',
                type: "String",
                label: 'Key'
            },

        })
    }

}